import { render, staticRenderFns } from "./plist.vue?vue&type=template&id=f63b7bd6&scoped=true&"
import script from "./plist.vue?vue&type=script&lang=js&"
export * from "./plist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63b7bd6",
  null
  
)

export default component.exports